import {
  FLEXIGO_V3,
} from './base';

export const sse = {
  stream: `${FLEXIGO_V3}/sse/stream`,
  sseTest: `${FLEXIGO_V3}/sse/test`,
};

export default sse;
